import Chart from 'react-apexcharts';

const BarChart = ({ title, subtitle, label, series, categories, color = '#137dc5', horizontal = false }) => {
    return (
        <Chart
            options={{
                chart: {
                    type: 'bar',
                },
                title: {
                    text: title,
                    align: 'left',
                    style: {
                        fontSize: '16px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 650,
                    },
                },
                subtitle: {
                    text: subtitle,
                    align: 'left',
                    style: {
                        fontSize: '12px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 500,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal,
                    },
                },
                xaxis: {
                    categories: categories?.length ? categories : [],
                },
                labels: [label],
                colors: [color],
            }}
            series={series}
            type="bar"
            height={360}
            width="100%"
        />
    );
};

export default BarChart;
